import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance'
import {httpSendMail, HttpSendMailOptions} from '@/features/mailer/http/mailer.http'
import {captureException} from '@sentry/react'
import {SendMailResponse} from '@/features/mailer/types'
import {z} from 'zod'
import {MUTATION_KEYS} from '@/queryClient'

const ResponseShape = SendMailResponse
type ResponseShape = z.infer<typeof ResponseShape>

export const useSendMail = (
    options?: Omit<UseMutationOptions<ResponseShape, Error, HttpSendMailOptions, unknown>, 'mutationFn'>
) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.SEND_MAIL],
        mutationFn: (mutationParams: HttpSendMailOptions) =>
            parseAxiosPromise({
                axiosPromise: httpSendMail(mutationParams),
                onZodError: captureException,
                responseShape: ResponseShape
            }),
        ...options
    })
}
